import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withNamespaces } from 'react-i18next';
import { Launch } from '@material-ui/icons';
import { Tabs } from '../Header/Tabs';
import { Tab } from '../Header/Tab';
import { AssetsFileResolver } from '../../containers/AssetsFileResolver';
import { HEADER_HEIGHT, HEADER_FULLSCREEN_HEIGHT } from '../../../base/constants';
import { ExpandMore } from '../../../player/components/controls/buttons';
import { ExternalLink } from '../../../userAccount/components/ExternalLink';
import Volume from '../../../player/components/controls/Volume';

const Wrapper = styled.header`
  font-family: 'Pluto Sans SemiBold', sans-serif;
  color: #a8a8a8;
  display: ${({ isHeadless }) => (isHeadless ? 'none' : 'flex')};
  flex-flow: column;
  font-size: 18px;
  width: 100%;
  height: ${({ isFullscreen, isMobile }) =>
    isFullscreen && !isMobile ? HEADER_FULLSCREEN_HEIGHT : HEADER_HEIGHT + 46}px;
  z-index: 30;
`;

const Logo = styled(AssetsFileResolver)`
  position: relative;
  left: 20px;
  height: 30px;
  margin: 0.8em 1em 0.8em 0em;
`;

const ExpandButton = styled.div`
  visibility: ${({ isFullscreen }) => (!isFullscreen ? 'visible' : 'hidden')};
  font-size: 16px;
  height: 40px;
  min-width: 120px;
  display: inline-block;
  margin: 10px auto;
  width: 140px;
  background: #fff;
  position: relative;
  pointer-events: all;
  cursor: pointer;
  z-index: 6;
  border-radius: 20px;
  color: #000;
  text-align: center;
  box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.8);
  :hover {
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 1);
  }
  span {
    height: 20px;
    width: 80px;
    margin-left: 7px;
    padding-left: 4px;
    vertical-align: super;
    display: inline-block;
    white-space: nowrap;
  }
`;

const VolumeWrapper = styled.div`
  position: relative;
  width: 40px;
  padding-left: 25px;
  top: 7px;
  display: ${({ isFullscreen }) => (!isFullscreen ? 'flex' : 'none')};
  div {
    width: ${({ isMuted }) => (isMuted ? '36px !important' : '')};
    position: relative;
  }
  span,
  div div {
    display: ${({ isMuted }) => (isMuted ? 'none' : '')};
  }
  svg {
    position: absolute;
    top: 5px;
    left: 7px;
  }
`;

const OpenAppLink = styled(ExternalLink)`
  color: #fff;
  text-decoration: none;
  display: flex;
  span {
    line-height: 50px;
  }
  @media (max-width: 550px) {
    span {
      display: none;
    }
  }
`;

const LaunchIcon = styled(Launch)`
  margin: 15px 15px 15px 5px;
`;

const HeadOne = styled.div`
  display: flex;
`;

const HeadTwo = styled.div`
  display: ${({ isFullscreen }) => (!isFullscreen ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: center;
  height: 40px;
`;

class EmbedHeaderComponent extends PureComponent {
  static propTypes = {
    isFullscreen: PropTypes.bool.isRequired,
    hideGuide: PropTypes.func.isRequired,
    enableVOD: PropTypes.bool.isRequired,
    page: PropTypes.string.isRequired,
    redirectToWatch: PropTypes.func.isRequired,
    redirectToVod: PropTypes.func.isRequired,
    linkClickBeacon: PropTypes.func.isRequired,
    isMuted: PropTypes.bool.isRequired,
    volume: PropTypes.number.isRequired,
    unMute: PropTypes.func.isRequired,
    mute: PropTypes.func.isRequired,
    isHeadless: PropTypes.bool.isRequired,
  };

  volumeChange = (volume) => {
    const oldVolume = this.player && this.player.getVolume();
    if (oldVolume !== volume) {
      const options = {
        up: volume > oldVolume,
        level: volume,
      };
      this.props.volumeChange(options);
    }
  };

  setVolume = (newVolume) => {
    const volume = Math.trunc(newVolume);
    this.volumeChange(volume);
    if (this.player) {
      this.player.setVolume(volume);
    }
  };

  handleGuideButton = () => {
    if (this.props.isFullscreen) {
      this.props.showGuide();
    } else {
      this.props.hideGuide();
    }
  };

  render() {
    const {
      isFullscreen,
      enableVOD,
      page,
      t,
      redirectToWatch,
      redirectToVod,
      linkClickBeacon,
      isMuted,
      unmute,
      mute,
      volume,
      channelSlug,
      isHeadless,
    } = this.props;

    return (
      <Wrapper isFullscreen={isFullscreen} isHeadless={isHeadless}>
        <HeadOne>
          <Logo alt="Pluto TV logo" path="images/logo-new.svg" />
          <VolumeWrapper isMuted={isMuted} isFullscreen={isFullscreen}>
            <Volume
              isMuted={isMuted}
              volume={volume}
              mute={mute}
              unMute={unmute}
              setVolume={this.setVolume}
              playerIsFullscreen={isFullscreen}
            />
          </VolumeWrapper>
          {!isHeadless &&
            <ExpandButton onClick={this.handleGuideButton}>
              {!isFullscreen ? (
                  <span>{t('hide_guide_embed', 'Hide Guide')}</span>
              ) : ( 
                  <span>{t('show_guide_embed', 'Show Guide')}</span>
              )}
              <ExpandMore />
            </ExpandButton>
          }         
          <OpenAppLink onClick={linkClickBeacon} to={`https://pluto.tv/live-tv/${channelSlug}`}>
            <span>{t('open_web_app', 'Open Web App')}</span>
            <LaunchIcon />
          </OpenAppLink>
        </HeadOne>
        <HeadTwo isFullscreen={isFullscreen}>
          <Tabs {...this.props} value={page}>
            <Tab onClick={redirectToWatch} value="Watch">
              {t('live_tv')}
            </Tab>
            {enableVOD && (
              <Tab onClick={redirectToVod} value="Vod">
                {t('on_demand')}
              </Tab>
            )}
          </Tabs>
        </HeadTwo>
      </Wrapper>
    );
  }
}

EmbedHeaderComponent = withNamespaces()(EmbedHeaderComponent);
export { EmbedHeaderComponent };
